import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=651d78e3&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"
import style0 from "./problem.vue?vue&type=style&index=0&id=651d78e3&prod&lang=less&scoped=true"
import style1 from "./problem.vue?vue&type=style&index=1&id=651d78e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d78e3",
  null
  
)

export default component.exports